module.exports = __webpack_public_path__ + "img/Asset 6.a87788a9.png";